import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";


export const ProfileLoader = styled.div`
    position: relative;
    min-height: 400px;
`;


export const PopContainer = styled.div<{freeWidth?:boolean, normalPad?:boolean, mid?:boolean, bg?:string}>`
    background:${props => props.bg?props.bg:"#fff"};
    width:100%;
    max-width: ${props => props.freeWidth?"90vw":"400px"};
    margin-left:10px;
    margin-right:10px;
    height:100%;
    max-height: ${props => props.freeWidth?"90vh":"70vh"};
    padding: ${props => props.freeWidth?"20px 6px 20px 20px":"20px"};
    position: relative;
    margin-top: auto;
    color:#383838;
    border-radius: 14px;

    ${mq(Devices.tablet)}{
        border-radius:  ${props => props.mid?"14px":"14px 14px 0 0"};
        padding:${props => props .normalPad?"20px":"20px 20px 80px 20px"};
        max-height: 100vh;
        max-width: ${props => props.freeWidth?"90vw":"400px"};
    }
`;

export const HeadLine = styled.div`
    position: absolute;
    top: 60px;
    left:0;
    width:100%;
    
    border-bottom: 1px solid #d4d4d4;
`;


export const PopTitle = styled.div`
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 34px;
    z-index: 100;
    position: relative;
`;

export const PopSubTitle = styled.span<{icon?:boolean, expand?:boolean}>`
    font-size: 12px;
    font-weight: 400;
    padding-left:${props => props.icon?"20px":"0"};
    position: relative;
    color:#7e7e7e;
    display:flex;
z-index: 100;
    div{
        pointer-events: all;
        margin-left: auto;
        
        > svg{
            transform: ${props => props.expand?"rotateZ(-90deg)":"rotateZ(0deg)"};
            cursor: pointer;
            height:14px;
            width:14px;
            path{
                stroke:#7e7e7e;
            }
        }
    }

    > svg{
        position: absolute;
        left:0;
        top:1px;
        height:14px;
        width:14px;
        path{
            stroke:#7e7e7e;
        }
    }
`;

export const PopClose = styled.div`
    position: absolute;
    height:32px;
    width:32px;
    border-radius: 50%;
    top:14px;
    right:14px;
    z-index: 100;
    display:flex;
    align-items: center;
    justify-content: center;

    svg{
        height:38%;
        width:38%;
        path{
            fill:#7e7e7e;
        }
    }
    :hover{
        background:#ebebeb;
        cursor: pointer;
    }
`;

export const PopRow = styled.div<{topBorder?:boolean, col?:boolean}>`
    display:flex;
    flex-direction: ${props => props.col?"row":"column"};
    gap:${props => props.col?"12px":"4px"};
    padding: 6px 0;
    font-size: 16px;
    position: relative;

    > span{ 
        font-weight: 500;
    }

    textarea{
        height:80px;
        border: 1px solid #b4b4b4;
        border-radius: 6px;
        padding:12px;
        resize: none;
        outline: none;
    }
    
    select{
        border: 1px solid #b4b4b4;
        border-radius: 6px;
        padding:8px 12px;
        outline: none;
    }

    hr{
        margin:0;
        background:#ebebeb;
        border:none;
        height:1px;
    }
`;

export const CreateRow = styled.div`
    display:flex;
    align-items: center;
    gap:10px;

    > svg{
        margin-left: auto;
        width:20px;
    }
`;

export const PopCol = styled.div`
    width:50%;
    display:flex;
    flex-direction: column;
    gap:4px;

    > div{
        width:100%;
        .react-datepicker-wrapper{
            width:100%;
        }
    }
`;

export const PopCal = styled.div`
    
    display:flex;
    align-items: center;
    border: 1px solid #b4b4b4;
    border-radius: 6px;
    padding:8px 12px;
    svg{
        margin-left: auto;
        height:16px;
    }
`;


export const PopItem = styled.div`
    display:flex;
    flex-direction: column;
    background:#F9FAFB;
    border:1px solid #d4d4d4;
    border-radius:10px;
    padding: 4px 12px;
    margin-bottom: 10px;
`;

export const ChildContainer = styled.div`
    display:grid;
    grid-template-columns: 36px auto;
    gap:10px;
    font-size: 14px;
`;

export const ImageContainer = styled.div`
   position: relative;
   width:40px;
   height:40px;
   overflow: hidden;
   border-radius: 50px;
   > div{
    border-radius: 50px;
   }
`;

export const ChildInfo = styled.div`
   display:flex;
    flex-direction: column;
`;

export const PillContainer = styled.div`
   display:flex;
   gap:4px;
`;

export const TagPill = styled.div<{PColor?:string, big?:boolean}>`
   background:${props => props.big?props.PColor:"#dbdbdb"};
   color:#fff;
   border-radius: 30px;
   padding:${props => props.big?"2px 8px":"3px 10px"};
   font-size:  ${props => props.big?"10px":"10px"};
`;

export const TnfoText = styled.span<{icon?:boolean}>`
   font-size: 12px;
   font-weight: 500;
   line-height: 14px;
   padding-left:${props => props.icon?"20px":"0"};
`;

export const LessonList = styled.div`
   display:flex;
   flex-direction: column;
   gap:6px;
`;

export const LessonItem = styled.div`
   font-size: 12px;
   padding:5px 10px;
   background:#fff;
   border:1px solid #ececec;
   border-radius: 6px;
   display:flex;
   flex-direction: column;
   gap:4px;

   > div:nth-of-type(1){
    width:100%;
    display:flex;
    gap:10px;
    > div{
        display:flex;
        flex-direction: column;
        div {
            display:flex;
            gap:10px;
        }
    }
   }

   svg{
    margin-top: 4px;
    height:10px;
   }
`;



export const PopRowButtons = styled.div<{topBorder?:boolean}>`
    display:flex;
    gap:8px;
    margin-top: 20px;

    button{
        width:100%;
        padding:8px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        box-shadow: 0 0px 2px rgba(0,0,0,0.35);

        :nth-of-type(2){
            background:#2A848E;
            color:#fff;
        }
        :nth-of-type(1){

        }
    }
`;

export const Buttons = styled.div<{topBorder?:boolean}>`
    display:flex;
    gap:8px;
    margin-top: 10px;

    button{
        width:100%;
        padding:6px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        box-shadow: 0 0px 2px rgba(0,0,0,0.35);

        :nth-of-type(1){
            background:rgb(250, 80, 94);
            color:#fff;
        }
        :hover{
            opacity: 0.9;
        }
    }
`;

export const ItemButtons = styled.div<{topBorder?:boolean}>`
    display:flex;
    gap:8px;
    grid-column: 1 / span 2;
    border-top: 1px solid #dadada;
    padding-top:10px;
    
    button{
        width:100%;
        padding:6px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
        box-shadow: 0 0px 2px rgba(0,0,0,0.35);

        :nth-of-type(1){
            background:rgb(250, 80, 94);
            color:#fff;
        }

        :hover{
            opacity: 0.9;
        }
    }
`;

export const GuardianWrapper = styled.div`
    padding-top:138px;
    margin-bottom: 30px;
    display:flex; 
    gap:30px;

    > div{
        width:calc(25% - 23px);
        aspect-ratio: 1 / 1.3;
    }

    ${mq(Devices.custom1300)}{
        > div{
            width:calc(50% );
        }
    }

    ${mq(Devices.laptop)}{
        > div{
            width:calc(50% );
        }
    }

    ${mq(Devices.tablet)}{
        flex-direction: column;
        > div{
            width:calc(100%);
        }
        gap:20px;
        margin-bottom: 20px;
    }

`;

export const ProfilContent = styled.div`
    padding-top:138px;
    display:flex;
    width:100%;
    > div > div{
        border-radius: 10px;
        box-shadow: 0 1px 4px 2px rgba(0,0,0,0.1);

        :last-of-type{
            box-shadow: none !important; 
        }
    }

    > div{
        width:100%;
    }
`;

export const StatusCorner = styled.div`
    position: absolute;
    top:4px;
    right:0px;
    font-size: 14px;
    display:flex;
    gap:4px;

    svg{
        width:14px;
    }
`;

export const PopListContent = styled.div`
    max-height: calc(100% - 60px);
    overflow-y: auto;
`;